import React, { useState, useEffect, useContext } from 'react'
import InvoiceListHeader from './InvoiceListHeader'
import InvoiceListInner from './InvoiceListInner'
import InvoiceListFooter from './InvoiceListFooter'
import { appContext } from '../../../App'
import { getInvoiceListSettings, saveInvoiceListSettings, getWarehouses,
  getInvoiceList, deleteInvoice, getInvoiceById } from '../InvoiceFunctions'

export const invoiceListControllerContext = React.createContext()

function useInvoiceListController() {
  const app = useContext(appContext)
  const [warehouses, setWarehouses] = useState(null)
  const [warehouse, setWarehouse] = useState(null)
  const [invoiceList, setInvoiceList] = useState([])
  const [invoiceListCopy, setInvoiceListCopy] = useState(null)
  const [selectedInvoicesId, setSelectedInvoicesId] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [startSlice, setStartSlice] = useState(0)
  const [endSlice, setEndSlice] = useState(0)
  const [foundDeletableInvoice, setFoundDeletableInvoice] = useState(null)
  const [invoiceListSettings, setInvoiceListSettings] = useState(null)
  const [invoiceListSorted, setInvoiceListSorted] = useState(false)
  const [sortBy, setSortBy] = useState(null)

  const [recordPerPage, setRecordPerPage] = useState(null)
  const [recPP, setRecPP] = useState(null)
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const getTotalRecords = () => invoiceList.length

  const addSelectedInvoiceId = (invoice_id) => {
    setSelectedInvoicesId([...selectedInvoicesId, invoice_id])
  }

  const removeSelectedInvoiceId = (invoice_id) => {
    setSelectedInvoicesId(selectedInvoicesId.filter((id) => id !== invoice_id))
  }

  const deleteSelectedInvoices = async () => {
    // TODO: Check here if the item has pulled-out history
    // Well then it means I have to attached the pulled out history on the item itself
    // But this is optional since the item inventory is still restored only in a different form of unit
    for (const invoiceId of selectedInvoicesId) await deleteInvoice(app, invoiceId)

    getInvoiceList(app, invoiceListSettings)
    reloadInvoiceList()
  }

  const sortInvoiceListBy = (column) => {
    const sortByInvoiceDate = () => {
      invoiceList.sort((a, b) => {
        let sorted
        if (!invoiceListSorted)
          sorted = ((new Date(a.date_time_created).getTime()) - (new Date(b.date_time_created).getTime()))
        else
          sorted = ((new Date(b.date_time_created).getTime()) - (new Date(a.date_time_created).getTime()))
        return sorted
      })
    }

    const sortByInvoiceNumber = () => {
      invoiceList.sort((a, b) => {
        let x, y
        if (!invoiceListSorted) {
          x = a._id.toLowerCase()
          y = b._id.toLowerCase()
        } else {
          x = b._id.toLowerCase()
          y = a._id.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortBySoldTo = () => {
      invoiceList.sort((a, b) => {
        let x, y
        if (!invoiceListSorted) {
          x = a.customer_details.sold_to.toLowerCase()
          y = b.customer_details.sold_to.toLowerCase()
        } else {
          x = b.customer_details.sold_to.toLowerCase()
          y = a.customer_details.sold_to.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByPreparedBy = () => {
      invoiceList.sort((a, b) => {
        let x, y
        if (!invoiceListSorted) {
          x = (a.prepared_by) ? a.prepared_by.toLowerCase() : 0
          y = (b.prepared_by) ? b.prepared_by.toLowerCase() : 0
        } else {
          x = (b.prepared_by) ? b.prepared_by.toLowerCase() : 0
          y = (a.prepared_by) ? a.prepared_by.toLowerCase() : 0
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByStatus = () => {
      invoiceList.sort((a, b) => {
        let x, y
        if (!invoiceListSorted) {
          x = a.status.toLowerCase()
          y = b.status.toLowerCase()
        } else {
          x = b.status.toLowerCase()
          y = a.status.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByTotalSales = () => {
      invoiceList.sort((a, b) => {
        let sorted
        if (!invoiceListSorted)
          sorted = a.invoice_summary.total_sales - b.invoice_summary.total_sales
        else
          sorted = b.invoice_summary.total_sales - a.invoice_summary.total_sales
        return sorted
      })
    }

    switch (column) {
      case 'invoice_date': sortByInvoiceDate()
        break
      case 'invoice_number': sortByInvoiceNumber()
        break
      case 'sold_to': sortBySoldTo()
        break
      case 'prepared_by': sortByPreparedBy()
        break
      case 'invoice_status': sortByStatus()
        break
      case 'total_sales': sortByTotalSales()
        break
      default:
    }

    setInvoiceListSorted(!invoiceListSorted)
    setInvoiceList(invoiceList)
  }

  const filterInvoiceList = (searchString) => {
    let tempList = []
    invoiceListCopy.forEach((invoice, i) => {
      invoice.searchable_string = `${invoice._id} ${invoice.customer_details.sold_to} ${invoice.prepared_by} ${invoice.status}`
    })

    invoiceListCopy.forEach(invoice => {
      let found = true
      searchString.split(' ').forEach((search_string_item, i) => {
        found = (found && (invoice.searchable_string.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
      })
      if (found) tempList.push(invoice)
    })

    setInvoiceList(tempList)

    setAllCheck(false)
    setSelectAll(false)

    setPage(1)
  }

  const setAllCheck = (check) => {
    const invoicesCheckBoxes = document.querySelectorAll('.invoice-checkbox')
    let tempInvoiceIdList = []

    // Reset the list
    setSelectedInvoicesId([])

    // First checked all checkbox that is not checked
    invoicesCheckBoxes.forEach((checkBox, i) => {
      const invoiceId = checkBox.closest('.invoice-item').id
      if (check) tempInvoiceIdList.push(invoiceId)
      checkBox.checked = check
    })

    setSelectedInvoicesId(tempInvoiceIdList)
  }

  const updateInvoiceListSettings = async (settings) => {
    await saveInvoiceListSettings(app, settings)
    // Update the invoice list settings
    setRecordPerPage(settings.record_per_page)
    setRecPP(settings.record_per_page)
    setInvoiceListSettings(settings)
  }

  const reloadInvoiceList = async () => {
    const invoice_list = await getInvoiceList(app, invoiceListSettings)
    setInvoiceList(invoice_list)
    setInvoiceListCopy(invoice_list)
    setSortBy(null)
  }

  useEffect(() => {
    let isMounted = true
    
    const init = async () => {
      const invoice_list_settings = await getInvoiceListSettings(app)
      const warehouses = await getWarehouses(app)

      if (isMounted) {
        setRecordPerPage(invoice_list_settings.record_per_page)
        setRecPP(invoice_list_settings.record_per_page)
        setInvoiceListSettings(invoice_list_settings)
        setWarehouses([{name: '--All--', id: 0}, ...warehouses])
        setWarehouse(warehouses[0])
      }
    }

    if (isMounted) init()

    return (() => { isMounted = false })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // Reload list only if both warehouse and invoiceListSettings are not null
    // Hence it will avoid double reloading
    if (warehouse && invoiceListSettings) reloadInvoiceList()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warehouse, invoiceListSettings])

  useEffect(() => { setAllCheck(selectAll) }, [selectAll])

  useEffect(() => {
    if (invoiceList)
      setFoundDeletableInvoice(
        invoiceList.find(
          invoice => ((invoice.status === 'Unpaid') || (invoice.status === 'Inactive'))
        )
      )
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceList])

  useEffect(() => {
    // set total page
    setTotalPage(Math.ceil(getTotalRecords() / recordPerPage))
    // slice stockinlist
    setStartSlice((page - 1) * recordPerPage)
    setEndSlice(page * recordPerPage)
    
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceList, recordPerPage, page])

  const obj = {
    warehouse: [warehouse, setWarehouse],
    selectAll: [selectAll, setSelectAll],
    startSlice: [startSlice, setStartSlice],
    endSlice: [endSlice, setEndSlice],
    page: [page, setPage],
    recordPerPage: [recordPerPage, setRecordPerPage],
    recPP: [recPP, setRecPP],
    sortBy: [sortBy, setSortBy],
    refreshInvoiceList: reloadInvoiceList,
    invoiceList: [invoiceList, setInvoiceList],
    selectedInvoicesId: [selectedInvoicesId, setSelectedInvoicesId],
    addSelectedInvoiceId, removeSelectedInvoiceId,
    deleteSelectedInvoices,
    foundDeletableInvoice,
    updateInvoiceListSettings,
    invoiceListSettings,
    getInvoiceListSettings,
    filterInvoiceList,
    sortInvoiceListBy,
    invoiceListSorted,
    setAllCheck,
    getTotalRecords,
    getInvoiceById,
    totalPage,
    warehouses
  }

  return obj
}

function InvoiceListController() {
  const invoiceListController = useInvoiceListController()
  return (
    <React.Fragment>
      <invoiceListControllerContext.Provider value={invoiceListController}>
        <InvoiceListHeader />
        <InvoiceListInner />
        <InvoiceListFooter />
      </invoiceListControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(InvoiceListController)